import { render, staticRenderFns } from "./BaseStartTradingButton.vue?vue&type=template&id=37d1db42&scoped=true"
import script from "./BaseStartTradingButton.vue?vue&type=script&lang=js"
export * from "./BaseStartTradingButton.vue?vue&type=script&lang=js"
import style0 from "./BaseStartTradingButton.vue?vue&type=style&index=0&id=37d1db42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1db42",
  null
  
)

export default component.exports